import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { OperatorApprovedUsersModel } from '../_models/operator-approved-users-model';
import { SafeUser } from '../_models/safe-user';
import { OperatorModel } from '../_models/operator-model';
import { AuthenticationService } from '../_services/authentication.service';
import { UserAccountService } from '../_services/user-account.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MessageDialogComponent } from '../message-dialog/message-dialog.component';

@Component({
  selector: 'app-approver-cp',
  templateUrl: './approver-cp.component.html',
  styleUrls: ['./approver-cp.component.css']
})
export class ApproverCPComponent implements OnInit {

  public displayedColumns: string[] = ["UserId", "FirstName", "LastName", "Email", "IsApproved", "IsDenied", "OperationButtons"];

  public Operators: Array<any> = new Array<any>();

  constructor(
    public userAccountService: UserAccountService,
    public authenticationService: AuthenticationService,
    protected dialog: MatDialog
  )
  {

    this.authenticationService.currentUserSubject.subscribe((user) => {
      this.userAccountService.fetchMyApprovedUsers().then(
        (result) => {
          this.processMyApprovedUsersResults(result);
        },
        (err) => {

        });
    });

    
  }

  ngOnInit(): void {
  }

  processMyApprovedUsersResults(results: Array<OperatorApprovedUsersModel>) {

    results.forEach((operAppUserModel) => {
      var container = {
        operatorApprovedUsersModel: operAppUserModel,
        dataSource: new MatTableDataSource<SafeUser>(operAppUserModel.Users)
      };

      this.Operators.push(container);
    });
  }

  approveUser(u: SafeUser, o: OperatorApprovedUsersModel) {
    
    this.userAccountService.approverConfirmUser(u.Id, o.Id, u.ApproverConfirmationCode, "approve").then((result) => {
      if (result.Success) {
        this.userAccountService.fetchSafeUser(u.Id, o.Id).then((safeUser) => {
          var keys = Object.keys(safeUser);

          for (var i = 0; i < keys.length; i++) {
            u[keys[i]] = safeUser[keys[i]];
          }
        },
        (err) => {
        });
      }
    },
      (err) => {
        this.dialog.open(MessageDialogComponent, {
          data: {
            title: "Error",
            message: "Something went wrong while attempting to deny this user.  Please refresh the page and try again."
          }
        });
      });
    
  }

  denyUser(u: SafeUser, o: OperatorApprovedUsersModel) {
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: "Confirm User Denial",
        message: "Are you sure you wish to deny this user access?  The user will no longer be able to access the application."
      }
    }).afterClosed().subscribe(
      (result) => {
        if (result) {
          this.userAccountService.approverConfirmUser(u.Id, o.Id, u.ApproverConfirmationCode, "deny").then((result) => {
            this.userAccountService.fetchSafeUser(u.Id, o.Id).then((safeUser) => {
              var keys = Object.keys(safeUser);

              for (var i = 0; i < keys.length; i++) {
                u[keys[i]] = safeUser[keys[i]];
              }
            },
              (err) => {
              });
          },
            (err) => {
              this.dialog.open(MessageDialogComponent, {
                data: {
                  title: "Error",
                  message: "Something went wrong while attempting to deny this user.  Please refresh the page and try again."
                }
              });
            });
        }
      }
    );
  }
}
